import { create } from 'zustand';

interface ChatNotificationState {
  activePartnerId: string | null;
  setActivePartnerId: (partnerId: string | null) => void;
}

export const useChatNotificationStore = create<ChatNotificationState>((set) => ({
  activePartnerId: null,
  setActivePartnerId: (partnerId) => set({ activePartnerId: partnerId }),
}));
